

import $ from 'jquery';
import 'what-input';
// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


if ( document.getElementById('testfocus')!=null ) {


  $(document).ready(function(){
	/*var focusrechts = document.getElementById("focusrechts");
	focusrechts.addEventListener('click',function() {
		document.getElementById('hieristedoen').classList.add('refocus');
	})  */
	var focuslinks = document.getElementById("focuslinks");
	focuslinks.addEventListener('click',function() {
		document.getElementById('hieristedoen').classList.remove('refocus');
	})
  });


}


/*function Task(data) {
    this.title = ko.observable(data.title);
    this.isDone = ko.observable(data.isDone);
}

function TaskListViewModel() {
    // Data
    var self = this;
    self.tasks = ko.observableArray([]);
    self.newTaskText = ko.observable();
    self.incompleteTasks = ko.computed(function() {
        return ko.utils.arrayFilter(self.tasks(), function(task) { return !task.isDone() });
    });

    // Operations
    self.addTask = function() {
        self.tasks.push(new Task({ title: this.newTaskText() }));
        self.newTaskText("");
    };
    self.removeTask = function(task) { self.tasks.remove(task) };
    
    // Load initial state from server, convert it to Task instances, then populate self.tasks
    $.getJSON("/conversatie/json/tasks.txt", function(allData) {
            var mappedTasks = $.map(allData, function(item) { return new Task(item) });
            self.tasks(mappedTasks);
        });    
    }

ko.applyBindings(new TaskListViewModel());*/



/*var myViewModel = {
    docTitle: ko.observable("Default title"),
    docContent: ko.observable("<p>Default paragraph.</p>")
};

$.getJSON("/conversatie/json/testbinding.json", function(data){
    myViewModel.docTitle(data.longtitle);
    myViewModel.docContent(data.content);
    console.log(myViewModel);
});*/

// This is a simple *viewmodel* - JavaScript that defines the data and behavior of your UI
/*function ResourceViewModel(result) {
    
    var self = this ;
    self.docTitle = result.longtitle;
    self.docContent = result.content;
    $.getJSON("/conversatie/json/testbinding.json", function(data){
        var parsed = JSON.parse(data);
        result(parsed);
    })
}*/



// 2. The "callback" parameter is a reference to the function which
//    was passed as argument from the helloCatAsync call
/*function ResourceViewModel(callback) {
    console.log("2. callback here is the function passed as argument above...")
    // 3. Start async operation:
    $.getJSON("/conversatie/json/testbinding.json", function(data){
        callback('Nya');
    })

}

ResourceViewModel(function(result) {
    // 5. Received the result from the async function,
    //    now do whatever you want with it:
    console.log("5. result is: ", result);
});
*/


// 1. Call helloCatAsync passing a callback function,
//    which will be called receiving the result from the async operation

/*helloCatAsync(function(result) {
    var obj = JSON.parse(result) ;
    //var extracted = result.responseText;
    // 5. Received the result from the async function,
    //    now do whatever you want with it:
    console.log("5. result is: ", obj.longtitle);
});*/

// 2. The "callback" parameter is a reference to the function which
//    was passed as argument from the helloCatAsync call
/*function helloCatAsync(callback) {
    console.log("2. callback here is the function passed as argument above...")
    // 3. Start async operation:
    callback( $.ajax({ 
        type: "GET",
        async: true,
         url: "/conversatie/json/testbinding.json"
    }));
}*/

/*function helloCatAsync(callback) {
    console.log("2. callback here is the function passed as argument above...")
    // 3. Start async operation:
    $.ajax({ 
        type: "GET",
        dataType: 'text',
        async: true,
        url: "/conversatie/json/testbinding.json",
        success: function(data){
            callback(data);
        }
    });
}*/


/*function helloCatAsync(callback) {
    console.log("2. callback here is the function passed as argument above...")
    // 3. Start async operation:
    callback($.getJSON("https://vangilbergen.net/conversatie/json/testbinding.json",function(res) {
        var text = res.responseText;
        hello(text);
    })
    );
}
*/

/*$.ajax({ 
    type: "GET",
    dataType: 'text',
    async: true,
    url: "/conversatie/json/testbinding.json",
    success: function(data){
        console.log(data);
    }
});*/

//ko.applyBindings(myViewModel, document.getElementById('testjson'))

/*ResourceViewModel(function(result) {
    var obj = JSON.parse(result) ;
    var self = this ;
    self.docTitle = obj.longtitle;
    self.docContent = obj.content;
    
    //var extracted = result.responseText;
    // 5. Received the result from the async function,
    //    now do whatever you want with it:
    console.log("5. result is: ", obj.longtitle);
});*/





var ViewResouceModel = {
    longtitle: ko.observable("Test"),
    content: ko.observable("<p>Test</p>")
};

ko.applyBindings(ViewResouceModel);

function GetDataFromServer(myurl,callback) {
    console.log("1. function reached...")
    var fullurl = '/conversatie/json/'+myurl+'.json' ;
    console.log(fullurl);
    $.ajax({ 
        type: "GET",
        dataType: 'text',
        async: true,
        url: fullurl
    })
    .done(function(data){
        console.log("After the download ...");
        var obj = JSON.parse(data);
        console.log(obj);
        callback(obj);
    });
}

/*function ResourceViewModel(callback) {
    console.log("2. callback here is the function passed as argument above...")
    // 3. Start async operation:
    $.ajax({ 
        type: "GET",
        dataType: 'text',
        async: true,
        url: "/conversatie/json/testbinding.json",
        success: function(data){
            callback(data);
        }
    });
}*/



/*GetDataFromServer('testbinding',function(data) {
    console.log("Ik ben in de GetDataFromServer");
    console.log(data);
    ViewResouceModel.longtitle(data.longtitle);
    ViewResouceModel.content(data.content);
    ko.applyBindings(ViewResouceModel);
});*/




// Create a Landbot Access Point
const myLandbot = new LandbotFrameWidget({
  index: 'https://landbot.io/u/H-141183-KNCDK6PDVBW63ZED/index.html',
  container:'#dialoog',
});

myLandbot.on('refocus', () => {
  refocus();
  console.log('I get a message from the other side');
});

function refocus() {
    var element = document.getElementById('hieristedoen');
    element.classList.add('refocus');
    GetDataFromServer('testbinding',function(data) {
        console.log("Ik ben in de GetDataFromServer");
        console.log(data);
        ViewResouceModel.longtitle(data.longtitle);
        ViewResouceModel.content(data.content);
        ko.applyBindings(ViewResouceModel);
    });
}

// Parent site
myLandbot.on('say-hi', () => {
  console.log('OMG this website is talking to me!');
});

/*const progressBar = document.getElementById('progress-bar');
const progressBarValue = document.getElementById('progress-bar-value');
const messagesList = document.getElementById('messages-list');*/

// setProgress(0);

// Listen to incoming events
/*myLandbot.on('custom-progress', (data) => {
  setProgress(data.value);
});

myLandbot.on('landbot-msg-receive', (msg) => {
  appendMessage(msg);
});*/




// Sets Progress Bar Value
/*function setProgress(value) {
  progressBar.value = value;
  progressBarValue.textContent = `${value} %`;
}*/

// Appends message to messages list
/*function appendMessage(msg) {
  if (msg.samurai !== undefined) {
    const elem = document.createElement('p');
    elem.className = 'msg';
    elem.textContent = msg.title || msg.message;
    messagesList.append(elem);
  }
}*/
$(document).foundation();

